import React from 'react'
import { Link } from 'gatsby'
import { Box } from '@chakra-ui/react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { localisedLink } from '../../utils/utils'
import { EDU_LEVELS_SLUG, EDU_PAGE_SLUG, PAGE_SLUG, REGISTRATION_SLUG } from '../../lib/constants'

const MenuItem = ({ padding, menu, children }) => {
    const { i18n } = useTranslation()

    switch (menu?.internal?.type) {
        case 'ContentfulMenuItems':
            if (menu?.link?.id !== undefined && menu?.link?.id !== '') {
                return (
                    <MenuItem padding={padding} menu={menu?.link}>
                        {children}
                    </MenuItem>
                )
            } else {
                return (
                    <Box className={'menuitem'} p={padding} display={'block'}>
                        {children}
                    </Box>
                )
            }
        case 'ContentfulRegistrations':
            return (
                <Link to={localisedLink(i18n.language, REGISTRATION_SLUG, menu.slug)} style={{ display: `block`, width: '100%' }}>
                    <Box className={'menuitem'} p={padding} display={'block'} w={'100%'}>
                        {children}
                    </Box>
                </Link>
            )
        case 'ContentfulEducationalLevels':
            return (
                <Link to={localisedLink(i18n.language, EDU_LEVELS_SLUG, menu.slug)} style={{ display: `block`, width: '100%' }}>
                    <Box className={'menuitem'} p={padding} display={'block'} w={'100%'}>
                        {children}
                    </Box>
                </Link>
            )
        case 'ContentfulEduPage':
            return (
                <Link to={localisedLink(i18n.language, EDU_PAGE_SLUG, menu.slug)} style={{ display: `block`, width: '100%' }}>
                    <Box className={'menuitem'} p={padding} display={'block'}>
                        {children}
                    </Box>
                </Link>
            )
        case 'ContentfulPage':
            return (
                <Link to={localisedLink(i18n.language, PAGE_SLUG, menu.slug)} style={{ display: `block`, width: '100%' }}>
                    <Box className={'menuitem'} p={padding} display={'block'}>
                        {children}
                    </Box>
                </Link>
            )
        case 'ContentfulMenulink':
            return (
                <Link to={localisedLink(i18n.language, menu.linkTo, '')} style={{ display: `block`, width: '100%' }}>
                    <Box className={'menuitem _menuLink'} p={padding}>
                        {children}
                    </Box>
                </Link>
            )
        default:
            return (
                <Box className={'menuitem'} p={padding} style={{ display: `block` }}>
                    {children}
                </Box>
            )
    }
}

MenuItem.propTypes = {
    padding: PropTypes.number,
}

MenuItem.defaultProps = {
    padding: 0,
}

export default MenuItem
